import React from 'react';
import { ShieldCheckIcon, ZapIcon, FlameIcon, CheckIcon, RocketIcon, ArrowRightIcon, LockIcon, RefreshCwIcon, StarIcon, CheckCircleIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { useGeoPricingContext } from '../hooks/GeoPricingContext';
import { useViewerCount } from '../hooks/useViewerCount';
export function PurchaseSection() {
  const {
    minutes,
    seconds
  } = useCountdown(900);
  const {
    oldPrice,
    newPrice
  } = useGeoPricingContext();
  const viewerCount = useViewerCount(98);
  return <section id="comprar" className="bg-cream py-10 px-4" data-id="element-322">
      <div className="max-w-[500px] mx-auto" data-id="element-323">
        <div className="text-center mb-8" data-id="element-324">
          <h2 className="text-[28px] font-bold text-brand-black mb-2 flex items-center justify-center gap-2" data-id="element-325">
            <RocketIcon className="w-6 h-6 text-primary" data-id="element-326" />
            PRESENTAMOS…
          </h2>
          <h3 className="text-[22px] font-bold text-primary mb-3" data-id="element-327">
            Domina los Comandos Eléctricos en 24 Horas™
          </h3>
          <p className="text-dark-gray italic" data-id="element-328">
            "La guía práctica que convierte diagramas en acciones reales"
          </p>
        </div>

        {/* Video */}
        <div className="mx-auto overflow-hidden shadow-medium rounded-xl border border-white/10 mb-6 bg-brand-black-light" data-id="element-329">
          <video autoPlay loop muted playsInline preload="metadata" className="w-full h-auto block" data-id="element-330">
            <source src="https://cdn.magicpatterns.com/uploads/e3fJCnG9w2mKAgsypQS38r/2dO6p5E.mp4" type="video/mp4" data-id="element-331" />
          </video>
        </div>

        {/* Features list */}
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 mb-8 text-sm text-dark-gray" data-id="element-332">
          <div className="flex items-center gap-2" data-id="element-333">
            <CheckIcon className="w-4 h-4 text-success" data-id="element-334" /> 370 páginas full
            color
          </div>
          <div className="flex items-center gap-2" data-id="element-335">
            <CheckIcon className="w-4 h-4 text-success" data-id="element-336" /> Diagramas reales
          </div>
          <div className="flex items-center gap-2" data-id="element-337">
            <CheckIcon className="w-4 h-4 text-success" data-id="element-338" /> Explicación paso a
            paso
          </div>
          <div className="flex items-center gap-2" data-id="element-339">
            <CheckIcon className="w-4 h-4 text-success" data-id="element-340" /> Aplicación directa
          </div>
        </div>

        <div className="text-center mb-8" data-id="element-341">
          <p className="text-lg font-bold text-brand-black bg-brand-black-light py-2 px-4 rounded-lg inline-block border border-white/10 shadow-sm" data-id="element-342">
            No es teoría. Es un sistema.
          </p>
        </div>

        {/* Offer Box */}
        <div className="bg-brand-black-light rounded-xl p-6 mx-auto border-2 border-primary shadow-gold animate-subtle-glow" data-id="element-343">
          <div className="text-center mb-2 text-dark-gray text-sm uppercase tracking-wider font-semibold" data-id="element-344">
            PRECIO DE OFERTA
          </div>
          <div className="flex flex-col items-center gap-1 leading-none text-center" data-id="element-345">
            <span className="text-xl line-through text-dark-gray font-bold" data-id="element-346">
              {oldPrice}
            </span>
            <div className="text-primary font-bold mt-2 mb-1 flex items-center justify-center gap-2" data-id="element-347">
              <FlameIcon className="w-6 h-6" data-id="element-348" /> HOY SOLO:
            </div>
            <span className="text-[64px] font-black text-brand-black font-poppins tracking-tight leading-none" data-id="element-349">
              {newPrice}
            </span>
          </div>
          <div className="text-center mt-4 text-sm text-dark-gray" data-id="element-350">
            Pago único · Sin suscripciones · Sin cargos ocultos
          </div>
          <div className="flex justify-around mt-5 pt-5 border-t border-white/10 text-dark-gray text-xs font-semibold" data-id="element-351">
            <div className="flex items-center gap-1.5" data-id="element-352">
              <ShieldCheckIcon className="w-4 h-4 text-primary" aria-hidden="true" data-id="element-353" />
              Compra Segura
            </div>
            <div className="flex items-center gap-1.5" data-id="element-354">
              <ZapIcon className="w-4 h-4 text-primary" aria-hidden="true" data-id="element-355" />
              Acceso Instantáneo
            </div>
          </div>
        </div>

        {/* CTA */}
        <a href="https://dominaelcontrol.online/cart/50664044626153:1" onClick={() => window.fbq && window.fbq('track', 'AddToCart')} className="animate-pulse-big flex items-center justify-center gap-2 mx-auto mt-8 bg-gradient-to-br from-success to-emerald-600 text-white border-none py-4 px-6 text-lg font-bold rounded-full cursor-pointer shadow-[0_8px_20px_rgba(34,197,94,0.3)] text-center uppercase tracking-wide no-underline hover:translate-y-[-3px] hover:scale-[1.02] hover:shadow-[0_8px_20px_rgba(34,197,94,0.4)] transition-all duration-400" data-id="element-356">
          QUIERO ACCESO INMEDIATO
          <ArrowRightIcon className="w-5 h-5" data-id="element-357" />
        </a>
        {/* Trust Badges */}
        <div className="flex flex-col items-center gap-2 mt-5 text-sm text-dark-gray font-medium" data-id="element-358">
          <div className="flex items-center gap-3" data-id="element-359">
            <span className="flex items-center gap-1" data-id="element-360">
              <LockIcon className="w-4 h-4 text-primary" data-id="element-361" /> Garantía 7 Días
            </span>
            <span data-id="element-362">·</span>
            <span className="flex items-center gap-1" data-id="element-363">
              <ZapIcon className="w-4 h-4 text-primary" data-id="element-364" /> Acceso Inmediato
            </span>
          </div>
          <div className="flex items-center gap-1" data-id="element-365">
            <RefreshCwIcon className="w-4 h-4 text-primary" data-id="element-366" /> Actualizaciones
            diarias de por vida
          </div>
          <div className="bg-[#1A1D24] border border-white/10 rounded-full px-4 py-1.5 flex items-center gap-2 mt-1" data-id="element-367">
            <div className="flex text-primary" data-id="element-368">
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-369" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-370" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-371" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-372" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-373" />
            </div>
            <span className="text-white font-bold text-xs" data-id="element-374">
              4.9/5{' '}
              <span className="text-dark-gray font-normal" data-id="element-375">
                +2.554 Electricistas
              </span>
            </span>
            <CheckCircleIcon className="w-4 h-4 text-blue-500 fill-white" data-id="element-376" />
          </div>
        </div>

        {/* Urgency Warning */}
        <div className="bg-red-900/40 border-2 border-red-500 rounded-xl p-5 mt-8 text-center shadow-[0_0_20px_rgba(239,68,68,0.3)]" data-id="element-377">
          <h3 className="text-red-500 text-[22px] font-black mb-2 flex items-center justify-center gap-2 uppercase tracking-wide" data-id="element-378">
            <FlameIcon className="w-6 h-6" aria-hidden="true" data-id="element-379" />
            OFERTA SOLO POR HOY
          </h3>
          <p className="text-sm text-white font-medium leading-[1.4] mb-4" data-id="element-380">
            Reserva válida por tiempo limitado. Si sales, el precio puede subir.
          </p>
          <div className="flex justify-center gap-2.5 text-center" data-id="element-381">
            <div className="bg-red-950 py-2.5 px-4 rounded-lg min-w-[60px] border border-red-500/50 shadow-sm" data-id="element-382">
              <div className="text-[28px] font-bold text-white leading-none" data-id="element-383">
                {minutes}
              </div>
              <div className="text-[10px] uppercase text-red-200 mt-1.5 tracking-wider font-bold" data-id="element-384">
                Min
              </div>
            </div>
            <div className="bg-red-950 py-2.5 px-4 rounded-lg min-w-[60px] border border-red-500/50 shadow-sm" data-id="element-385">
              <div className="text-[28px] font-bold text-white leading-none" data-id="element-386">
                {seconds}
              </div>
              <div className="text-[10px] uppercase text-red-200 mt-1.5 tracking-wider font-bold" data-id="element-387">
                Seg
              </div>
            </div>
          </div>
        </div>

        {/* Urgency Badges */}
        <div className="max-w-[500px] mx-auto mt-6 flex flex-col gap-3" data-id="element-388">
          <div className="bg-brand-black-light border border-white/10 text-brand-black font-bold py-3 px-4 rounded-lg text-sm text-center shadow-sm flex items-center justify-center gap-3" data-id="element-389">
            <span className="inline-flex items-center gap-1.5 bg-red-600 text-white text-[10px] uppercase tracking-wider font-bold px-2.5 py-1 rounded-full animate-pulse" data-id="element-390">
              <span className="w-1.5 h-1.5 bg-white rounded-full" data-id="element-391"></span>
              EN VIVO
            </span>
            <span data-id="element-392">
              <strong data-id="element-393">
                <span className="text-primary" data-id="element-394">{viewerCount}</span> personas
              </strong>{' '}
              están viendo esta oferta
            </span>
          </div>
        </div>
      </div>
    </section>;
}